import { useState } from "react";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";
import ButtonHelp from "@atoms/ButtonHelp";
import { LinkMore } from "@atoms/LinkMore";
import { ProductCard } from "@atoms/ProductCard";
import { Section } from "@atoms/Section";
import { Testimonials } from "@atoms/Testimonials";
import { IMG_ABOUT_US } from "@config/images";
import Button from "@ds/components/Button";
import Text from "@ds/components/Text";
import FABScrollDown from "@fragments/FABScrollDown";
import { formattedDate } from "@helpers/dateTime";
import Footer from "@layouts/Footer";
import useAction from "../../hooks/useAction";
import useStyles from "./styles";
import type { IPropsPageTentangKami } from "src/pages/tentang-kami";
import DynamicImage from "@ds/components/DynamicImage";
import { InsightData } from "@libraries/repositories/insight/insight.redux";
import color from "@definitions/mui/color";
import useResponsive from "@helpers/useResponsive";
// import SvgPlayIcon from "@icons/Play";

const rand = () => {
  return Math.round(Math.random() * 20) - 10;
};

const getModalStyle = () => {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
};

const Desktop: React.FC<IPropsPageTentangKami> = ({ dataNavbar }) => {
  const { testimony, insightList, corporateReview, dataAbout } = useAction();
  const { t } = useTranslation("common");
  const [modalStyle] = useState(getModalStyle);
  const classes = useStyles();
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const isTablet = useResponsive("lg");
  const [open, setOpen] = useState(false);
  const isInsightStoryExist = insightList?.data?.length !== 0;
  const tabletPadding = isTablet ? "110px" : "auto";

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const handleContactUs = () => {
    window.location.href = `${window.location.origin}/interest-form`;
  };

  const onClickToForm = () => {
    return document.querySelector("#uvp-about")?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <Box position="relative" mt="70px" minHeight="100vh">
      <Section bgcolor="white" maxWidth="full-width" pt={5} pb={7} px={tabletPadding}>
        <Container maxWidth="lg" disableGutters>
          <Grid container direction="row" alignItems="center" justifyContent="space-between">
            <Grid item xs={7}>
              <Text
                component="h1"
                variant="h1"
                weight="700"
                sx={{
                  fontSize: 36,
                  lineHeight: "54px",
                  marginBottom: 16,
                }}
              >
                {t("about.title")}
              </Text>
              <Text component="p" variant="body1" color="general-mid" sx={{ marginBottom: 16 }}>
                {t("about.desc1")}
              </Text>
              <Text component="p" variant="body1" color="general-mid" sx={{ marginBottom: 36 }}>
                {t("about.desc2")}
              </Text>
            </Grid>
            <Grid item xs={5} display="flex" justifyContent="flex-end">
              <Box
                maxWidth={isDesktop ? "420px" : "100%"}
                marginTop={isDesktop ? 0 : "40px"}
                position="relative"
                height={320}
                borderRadius={6}
                overflow="hidden"
              >
                {/* <Box
                    position="absolute"
                    onClick={handleOpen}
                    sx={{
                      svg: {
                        width: "100px",
                        height: "100px",
                      },
                      cursor: "pointer",
                    }}
                  >
                    <SvgPlayIcon />
                  </Box> */}
                <DynamicImage src={IMG_ABOUT_US} alt="img_about_mytens" />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Section>

      <Section variant="gray" maxWidth="full-width" id="uvp-about" px={tabletPadding}>
        <Container maxWidth="lg" disableGutters>
          <Box textAlign="center" mb={6}>
            <Text variant="h1" weight="700" sx={{ fontSize: 28 }}>
              {t("about.uvp.title")}
            </Text>
          </Box>
          <Box display="flex">
            {dataAbout.map((item, idx) => (
              <Box
                key={idx}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection="column"
                textAlign="center"
              >
                <Box mb={2}>
                  <img src={item.image} alt={item.title} width={120} height={120} />
                </Box>
                <Text component="h3" variant="h2" weight="700" sx={{ marginBottom: 16 }}>
                  {item.title}
                </Text>
                <Text color="general-mid" variant="body1" sx={{ padding: "0 12px" }}>
                  {item.description}
                </Text>
              </Box>
            ))}
          </Box>
        </Container>
      </Section>

      <Section py={10} px={tabletPadding}>
        <Container maxWidth="lg" disableGutters>
          <Grid container flexDirection="row-reverse" justifyContent="space-between">
            <Grid maxWidth="480px" item xs={6} sx={{ ".slick-dots": { bottom: "20px" } }}>
              <Testimonials data={testimony} minHeight="343px" />
            </Grid>
            <Grid item xs={6}>
              <Box pr={4} pb={3}>
                <Text className={classes.titleReguler} variant="h2" weight="700">
                  {t("about.testimony.title")}
                </Text>
              </Box>
              {corporateReview.map((item, index) => (
                <Box
                  display="flex"
                  alignItems="center"
                  marginBottom={item.point === "1.540+" ? 0 : "32px"}
                  key={index}
                >
                  <Box
                    width="48px"
                    height="48px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="#E2E4E5"
                    borderRadius="50%"
                    marginRight="16px"
                  >
                    <Box component="img" src={item.image} alt={item.title} />
                  </Box>
                  <Box>
                    <Box fontSize="24px" fontWeight="bold" marginBottom="6px">
                      {item.point}
                    </Box>
                    <Box fontWeight="600">{item.title}</Box>
                  </Box>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Container>
      </Section>

      {!!isInsightStoryExist && (
        <Section pt={0} maxWidth="full-width" px={tabletPadding}>
          <Container maxWidth="lg" disableGutters>
            <Box borderBottom="1px solid #CAD2E2" mb={6} />
            <Box display="flex" justifyContent="space-between" alignItems="baseline" mb="24px">
              <Typography component="h2" variant="h3">
                {t("testimoni.stories")}
              </Typography>
              <LinkMore text={t("about.seeMore")} href="/insight" withIcon />
            </Box>
            <Grid container spacing={4}>
              {insightList?.data?.slice(0, 2).map((item: InsightData) => (
                <Grid item xs={6} key={item.id}>
                  <ProductCard
                    title={item.title}
                    htmlDescription={item.story}
                    subTitle={formattedDate(item.date)}
                    image={item.imageUrl.mediaPath}
                    imageHeight={200}
                    height="376px"
                    overflow="hidden"
                    withImagePlaceholder
                    titleMaxLine={2}
                    linkTo={`/insight/${item.slug}`}
                    textColor={color.general.main}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Section>
      )}

      <Section variant="white" paddingY="60px" maxWidth="full-width" className={classes.gainAccess} px={tabletPadding}>
        <Container maxWidth="lg" disableGutters>
          <Box maxWidth={720} pb={2}>
            <Text className={classes.title} variant="h2" weight="700" color="white">
              {t("about.titleInterest")}
            </Text>
            <Box mb={5}>
              <Text variant="body1" color="white">
                {t("about.descInterest")}
              </Text>
            </Box>
            <Button size="large" onClick={handleContactUs}>
              {t("about.buttonInterest")}
            </Button>
          </Box>
        </Container>
      </Section>
      <Footer bgColor="grey-mid" dataNavbar={dataNavbar} />
      <ButtonHelp />
      <FABScrollDown data-testid="fab-test" onClick={onClickToForm} />
      <Modal open={open} onClose={handleClose}>
        <div style={modalStyle} className={classes.paper}>
          <iframe
            width="700"
            height="500"
            src="https://www.youtube.com/embed/ud322_5-M3s?autoplay=true"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            css={{ border: 0 }}
          />
        </div>
      </Modal>
    </Box>
  );
};

export default Desktop;
